export default __webpack_public_path__ + "static/media/img8.cf8a4b15.png";